/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */
/* eslint-disable css-modules/no-unused-class, css-modules/no-undef-class */
import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';

import { UserShape, openSignInModal, signOut } from '../../actions/user';

import s from './MyAccountButton.css';
import Link from '../Link';

const messages = defineMessages({
  signin: {
    id: 'navigation.signin',
    defaultMessage: '##Sign In##',
    description: 'Sign In link in header',
  },
  signOut: {
    id: 'navigation.signout',
    defaultMessage: '##Sign Out##',
    description: 'Sign Out link in header',
  },
  hiUser: {
    id: 'navigation.hiUser',
    defaultMessage: '##Hi {userName}##',
    description:
      'Label displayed when user already logged in. Do not remove or translate tre {userName} path',
  },
  myaccount: {
    id: 'navigation.myaccount',
    defaultMessage: '##My Account##',
    description: 'My Account link in header',
  },
});

class MyAccountButton extends React.Component {
  static propTypes = {
    user: UserShape,
    openSignInModal: PropTypes.func,
    signOut: PropTypes.func,
  };

  static defaultProps = {
    user: null,
    openSignInModal: () => {},
    signOut: () => {},
  };

  static contextTypes = {
    intl: intlShape,
  };

  onClickSignIn = () => {
    this.props.openSignInModal();
  };

  onClickSignOut = () => {
    this.props.signOut();
  };

  render() {
    const {
      user: { isLoggedIn, user },
    } = this.props;
    return (
      <div className={cx(s.root, s[this.context.intl.locale])}>
        <Link className={s.link} to={isLoggedIn ? '/account' : '/sign-in'}>
          <div className={s.background}>
            {isLoggedIn ? (
              <FormattedMessage
                {...messages.hiUser}
                values={{
                  userName: user.first_name,
                }}
              />
            ) : (
              <FormattedMessage {...messages.myaccount} />
            )}
          </div>
        </Link>
        {isLoggedIn ? (
          <button onClick={this.onClickSignOut}>
            <FormattedMessage {...messages.signOut} />
          </button>
        ) : (
          <button onClick={this.onClickSignIn}>
            <FormattedMessage {...messages.signin} />
          </button>
        )}
      </div>
    );
  }
}

const mapState = state => ({
  user: state.user,
});

const mapDispatch = {
  openSignInModal,
  signOut,
};

export default connect(
  mapState,
  mapDispatch,
)(withStyles(s)(MyAccountButton));
